<template>
  <v-dialog
    v-model="display"
    :width="dialogWidth"
    persistent
  >
    <template #activator="{ on }">
      <v-text-field
        v-bind="textFieldProps"
        outlined
        :disabled="disabled"
        :loading="loading"
        :label="label"
        :value="formattedDatetime"
        hide-details
        append-icon="mdi-calendar"
        v-on="on"
        readonly
        :rules="dateRule"
      >
        <template #progress>
          <slot name="progress">
            <v-progress-linear
              color="primary"
              indeterminate
              absolute
              height="2"
            />
          </slot>
        </template>
      </v-text-field>
    </template>

    <v-card>
      <v-card-text style="padding: 0;">
        <v-tabs
          fixed-tabs
          v-model="activeTab"
        >
          <v-tab key="timer">
            <slot name="timeIcon">
              <v-icon>mdi-clock</v-icon>
            </slot>
          </v-tab>
          <v-tab key="calendar">
            <slot name="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </slot>
          </v-tab>
          <v-tab-item key="timer">
            <v-time-picker
              ref="timer"
              width="300"
              :landscape="$vuetify.breakpoint.mdAndUp"
              header-color="green"
              class="v-time-picker-custom mx-5"
              v-model="time"
              v-bind="timePickerProps"
              :min="minTime"
              :max="maxTime"
            />
          </v-tab-item>
          <v-tab-item key="calendar">
            <v-date-picker
              v-model="date"
              @input="showTimePicker"
              full-width
              :min="minDate"
              :max="maxDate"
            />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <slot
          name="actions"
          :parent="this"
        >
          <v-btn
            text
            @click="cancelHandler"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="okHandler"
          >
            {{ okText }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { format, parse } from 'date-fns'
const DEFAULT_DATE = ''
const DEFAULT_TIME = '00:00:00'
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_TIME_FORMAT = 'HH:mm:ss'
const DEFAULT_DIALOG_WIDTH = 500
const DEFAULT_CLEAR_TEXT = 'CLEAR'
const DEFAULT_OK_TEXT = 'OK'
export default {
  name: 'VDatetimePicker',
  model: {
    prop: 'datetime',
    event: 'input'
  },
  props: {
    datetime: {
      type: [Date, String],
      default: null
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    dialogWidth: {
      type: Number,
      default: DEFAULT_DIALOG_WIDTH
    },
    dateFormat: {
      type: String,
      default: DEFAULT_DATE_FORMAT
    },
    timeFormat: {
      type: String,
      default: 'HH:mm'
    },
    minDate: {
      type: [Date, String],
      default: null
    },
    minTime: {
      type: [Date, String],
      default: null
    },
    maxDate: {
      type: [Date, String],
      default: null
    },
    maxTime: {
      type: [Date, String],
      default: null
    },
    okText: {
      type: String,
      default: DEFAULT_OK_TEXT
    },
    textFieldProps: {
      type: Object,
      default: null
    },
    timePickerProps: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      display: false,
      activeTab: 0,
      date: DEFAULT_DATE,
      time: DEFAULT_TIME,
      dateRule: [v => !!v || 'Item is required']
    }
  },
  created() {
    if (!this.datetime) {
      return
    }
    let initDateTime
    if (this.datetime instanceof Date) {
      initDateTime = this.datetime
    } else if (typeof this.datetime === 'string' || this.datetime instanceof String) {
      initDateTime = parse(this.datetime, this.dateTimeFormat, new Date())
    }
    this.date = format(initDateTime, DEFAULT_DATE_FORMAT)
    this.time = format(initDateTime, DEFAULT_TIME_FORMAT)
  },
  computed: {
    dateTimeFormat() {
      return this.dateFormat + ' ' + this.timeFormat
    },
    defaultDateTimeFormat() {
      return DEFAULT_DATE_FORMAT + ' ' + DEFAULT_TIME_FORMAT
    },
    formattedDatetime() {
      return this.selectedDatetime ? format(this.selectedDatetime, this.dateTimeFormat) : ''
    },
    selectedDatetime() {
      if (this.date && this.time) {
        let datetimeString = this.date + ' ' + this.time
        if (this.time.length === 5) {
          datetimeString += ':00'
        }
        return parse(datetimeString, this.defaultDateTimeFormat, new Date())
      } else {
        return null
      }
    },
  },
  methods: {
    cancelHandler() {
      this.resetPicker()
    },
    okHandler() {
      this.resetPicker()
      this.$emit('input', this.selectedDatetime)
    },
    resetPicker() {
      this.display = false
      this.activeTab = 0
      if (this.$refs.timer) {
        this.$refs.timer.selectingHour = true
      }
    },
    showTimePicker() {
      this.activeTab = 1
    }
  }
}
</script>